/**
 * CSS media query hook
 *
 * Subscribes to `matchMedia` for responsive onboarding layout (e.g. marquee columns).
 */

import { useEffect, useState } from 'react';

/**
 * Returns whether the given media query currently matches.
 *
 * @param {string} query Valid `matchMedia` query string.
 * @return {boolean} True when the query matches.
 */
export function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') {
      return false;
    }
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = () => setMatches(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return matches;
}
